'use client'

import { Autoplay } from 'swiper'
import { useTranslations } from 'next-intl'
import { Swiper, SwiperSlide } from 'swiper/react'

import { IconCard } from '@/components/common'
import { Global, Translate, Verify } from '@/components/icons'

const Opportunity = () => {
  const t = useTranslations('Opportunity')

  const opportunities = [
    {
      icon: <Verify className="h-9 w-9" />,
      title: t('item_one.title'),
      description: t('item_one.description'),
    },
    {
      icon: <Global className="h-9 w-9" />,
      title: t('item_two.title'),
      description: t('item_two.description'),
    },
    {
      icon: <Translate className="h-9 w-9" />,
      title: t('item_three.title'),
      description: t('item_three.description'),
    },
  ]
  return (
    <section className="container mx-auto py-[30px] md:py-12">
      <h2 className="mb-5 text-center md:mb-10">{t('title')}</h2>
      <Swiper
        modules={[Autoplay]}
        autoplay
        breakpoints={{
          428: { slidesPerView: 1 },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
        spaceBetween={24}
        className="mb-5 md:mb-10"
      >
        {opportunities.map((props, i) => (
          <SwiperSlide key={'opportunity-card' + props.title + i}>
            <IconCard key={i + props.title} {...props} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default Opportunity
